import { HttpErrorResponse } from '@angular/common/http';
import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { catchError, finalize, of, tap } from 'rxjs';
import { DigoService } from 'src/app/services/digo.service';
import { AlertDialogComponent } from 'src/app/shared/components/alert-dialog/alert-dialog.component';

@Component({
    selector: 'app-hm-modal-contract-conditions',
    templateUrl: './hm-modal-contract-conditions.component.html',
    styleUrls: ['./hm-modal-contract-conditions.component.css'],
    standalone: false
})
export class HmModalContractConditionsComponent {
    @Input() pdv: any;
    @Input() responseContractConditions: any;
    @Output() modalClosed = new EventEmitter<void>();

    // isSendingCommissions = false;
    // hasSentCommissions = false;
    // errorMessage: string | null = null;
    // canResend = false; // Si han pasado más de 5 minutos retornará true para permitir reenviar los contratos
    // isSignatureRequestActive = false; // Si el usuario ha iniciado la firma de los contratos retornará true
    // isCheckingSignature = false;
    // documentsSignedSuccess = false;
    // docsSignedPendingCheck = false;
    // docsSignaturePending = false;

    // pdfUrlRaw = 'assets/documento.pdf';
    // pdfSafeUrl!: SafeResourceUrl;
    // checkAceptado = false;

    // Usamos el tipo SafeResourceUrl en lugar de un string común
    pdfSafeUrl!: SafeResourceUrl;

    // @ViewChild('modalTitle') modalTitle!: ElementRef;
  
    textRead = false;

    constructor(
        public activeModal: NgbActiveModal,
        private digoService: DigoService,
        private sanitizer: DomSanitizer,
        private matDialog: MatDialog
    ) {}

    ngOnInit() {
        console.log('responseContractConditions -->', this.responseContractConditions);
        const rutaPdf = 'assets/pdf/COMUNICADO PENALIZACIONES y SIMYO PREPAGO AL CONTRATO DE PDV.pdf';
        // Le decimos a Angular que confíe en el archivo"
        this.pdfSafeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(rutaPdf);
    }

    // ngAfterViewInit() {
    //     this.modalTitle?.nativeElement?.focus();
    // }

    acceptContractConditions() {
        this.digoService.acceptConditionsContract().subscribe({
            next: (resp: any) => {
                if (resp && resp.msg && resp.msg === 'ok') {
                    this.digoService.resolveConditionsContractBlock();
                    this.closeModal();
                }
            },
            error: (error: HttpErrorResponse) => {
                if (error && error.status === 409) {
                    this.digoService.resolveConditionsContractBlock();
                    this.closeModal();
                    this.matDialog.open(AlertDialogComponent, {
                        data: { message: error.error.msg }
                    });
                } 
            }
        });
    }

    closeModal() {
        // this.activeModal.dismiss();
        this.activeModal.dismiss('accepted');
        this.modalClosed.emit(); // Notifica al padre que se ha cerrado el modal
    }
}
